import billingOrder from "~/schemas/schema.billingOrder.jsx";
import { arrayOfSubscriptionPlans, pricingModel } from "~/schemas/schema.subscription_plans.jsx";
import * as actionTypes from "~/store/action_types";
import { getCurrentPlanName } from "~/store/selectors/selector.accountSettings.jsx";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchPlans = () => {
  return {
    types: [
      actionTypes.FETCH_SUBSCRIPTION_PLANS_LOADING,
      actionTypes.FETCH_SUBSCRIPTION_PLANS_SUCCESS,
      actionTypes.FETCH_SUBSCRIPTION_PLANS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/plans`,
      }),
    payload: {
      schema: {
        plans: arrayOfSubscriptionPlans,
        pricing_model: pricingModel,
      },
    },
  };
};

export const switchToPlan = (plan, monthly = false, addons = []) => {
  return {
    types: [
      actionTypes.SWITCH_TO_SUBSCRIPTION_PLAN_LOADING,
      actionTypes.SWITCH_TO_SUBSCRIPTION_PLAN_SUCCESS,
      actionTypes.SWITCH_TO_SUBSCRIPTION_PLAN_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/order`,
        method: `POST`,
        body: {
          plan,
          billing_period: monthly ? `monthly` : `annually`,
          addons,
        },
      }),
    payload: {
      attributes: { plan, monthly, addons },
      schema: {
        single: billingOrder,
      },
    },
  };
};

export const activateFreePlan = (surveyData, is_from_cancellation = false) => {
  return {
    types: [
      actionTypes.SWITCH_TO_SUBSCRIPTION_PLAN_LOADING,
      actionTypes.SWITCH_TO_SUBSCRIPTION_PLAN_SUCCESS,
      actionTypes.SWITCH_TO_SUBSCRIPTION_PLAN_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/activate-free-plan`,
        method: `POST`,
        body: {
          survey_data: surveyData,
          is_from_cancellation: is_from_cancellation,
        },
      }),
  };
};

export const switchToAnnualBilling =
  (plan = null) =>
  (dispatch, getState) => {
    if (!plan) {
      let state = getState();
      plan = getCurrentPlanName(state);
    }

    return dispatch(switchToPlan(plan, false));
  };

export const switchIsMonthly = (isMonthly) => {
  return {
    type: actionTypes.SWITCH_IS_MONTHLY,
    isMonthly,
  };
};
